/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { ChartParms } from "@src/app/model/sys/nav-item";
import { RequestTemplateComponent } from "@src/app/modules/crm/request-template/request-template.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const RequestTemplatePageNavRoute = new NavRoute('crm/requestTemplates', ()=>RequestTemplateComponent, 'pattern').setCharts([
    { type: 'bar', picklist: 'categoryId' } as ChartParms,
    { type: 'pie', picklist: 'priorityId' } as ChartParms,
    { type: 'pie', picklist: 'frequencyId' } as ChartParms,
]);